<template>
    <div id="lognote">
        <v-alert dense border="bottom" type="primary" icon="mdi-information"
            >LOG NOTE</v-alert
        >
        <v-alert>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12" sm="6" md="4">
                            <v-switch
                                v-model="log.status_eeg"
                                class="ma-1 pa-3"
                                label="Wo Note"
                                v-if="detailcase.project_name == 'CDAX'"
                                hide-details
                            ></v-switch>
                            <v-switch
                                v-model="log.Attachment"
                                class="ma-1 pa-3"
                                label="Attachment CSO"
                                v-if="
                                    detailcase.project_name == 'CDAX' &&
                                        log.status_eeg == true
                                "
                                hide-details
                            ></v-switch>
                            <v-autocomplete
                                v-if="log.status_eeg == true"
                                :items="[
                                    'Part need to order',
                                    'Additional Part - Wrong part Ordered',
                                    'Additional Part - Part Damage',
                                    'Additional Part - Wrong part Shipped',
                                    'Additional Part',
                                    'Part Received',
                                    'Customer expected Response <DT>',
                                    'ADP - HP Pending',
                                    'ADP - Partner Pending',
                                    'DOA- HP Pending',
                                    'DOA- Partner Pending',
                                    'Elevation - Partner Pending',
                                    'Elevation - HP Pending',
                                    'Engineer Assignment Pending',
                                    'Partially part recd',
                                    'Part need to order',
                                    'Additional Part - Part Damage',
                                    'Additional Part - Wrong part Ordered',
                                    'Additional Part - Part Damage',
                                    'Additional Part - Wrong part Shipped',
                                    'Additional Part',
                                    'Customer Denied Service',
                                    'Rework – Customer Movement',
                                    'Rework – partner reassignment',
                                    'Under Observation',
                                    'QC Pass (Bench)',
                                    'Rework Trade -OTC to be changed',
                                    'Trade -PO/Payment awaited',
                                    'Trade -Price Awaited',
                                    'Trade -QI (Quote To Be Share)',
                                    'Part Backorder',
                                    'Trade - Quote Approved',
                                    'Trade - Quote Cancelled',
                                    'Trade - Quote Generated',
                                    'CRT - Open',
                                    'FRF/FA ',
                                    'Refund',
                                ]"
                                v-model="log.eeg_note"
                                label="Select Wo Note"
                                dense
                            ></v-autocomplete>
                            <v-textarea
                                v-model="log.log_note"
                                label="Noted"
                            ></v-textarea>
                            <v-btn
                                v-if="detailcase.main_status_name != 'Cancel'"
                                @click="saveLog()"
                                tile
                                color="success"
                            >
                                <v-icon left>mdi-content-save</v-icon>Save
                                Log</v-btn
                            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <v-btn
                                v-if="status == 'CloseCase'"
                                @click="doCopy()"
                                tile
                                color="primary"
                            >
                                <v-icon left>mdi-content-copy</v-icon>Copy Log
                            </v-btn>
                        </v-col>
                        <v-col
                            cols="12"
                            sm="6"
                            :md="
                                detailcase.cdax_log !== null ||
                                detailcase.nonhp_log !== null
                                    ? 4
                                    : 8
                            "
                        >
                            <!--  -->
                            <v-card class="mx-auto" elevation="0">
                                <v-textarea
                                    v-model="detailcase.lognote"
                                    label="LOG HYBRID"
                                    solo
                                    flat
                                    readonly
                                    outlined
                                    height="235"
                                    persistent-hint
                                    hint="HYBRID LOGNOTE"
                                ></v-textarea>
                            </v-card>
                        </v-col>
                        <v-col
                            cols="12"
                            sm="6"
                            md="4"
                            v-if="detailcase.cdax_log !== null"
                        >
                            <v-card class="mx-auto" elevation="0">
                                <v-textarea
                                    v-model="detailcase.cdax_log.log"
                                    label="LOG HP"
                                    solo
                                    flat
                                    readonly
                                    outlined
                                    height="235"
                                    persistent-hint
                                    hint="HP LOGNOTE"
                                ></v-textarea>
                            </v-card>
                        </v-col>

                        <v-col
                            cols="12"
                            sm="6"
                            md="4"
                            v-if="
                                detailcase.nonhp_log.log != '' &&
                                    detailcase.nonhp_log.log != null
                            "
                        >
                            <v-card class="mx-auto" elevation="0">
                                <v-textarea
                                    v-model="detailcase.nonhp_log.log"
                                    label="LOG "
                                    solo
                                    flat
                                    readonly
                                    outlined
                                    height="235"
                                    persistent-hint
                                    hint="LOGNOTE"
                                ></v-textarea>
                            </v-card>
                        </v-col>
                    </v-row>
                    <hr />

                    <div class="text-center">
                        <v-form method="post" id="nativeForm" v-model="valid">
                            <v-dialog v-model="dialog" width="500">
                                <v-card>
                                    <v-card-title
                                        class="text-h5 grey lighten-2"
                                    >
                                        Upload File
                                    </v-card-title>

                                    <v-card-text>
                                        <v-file-input
                                            counter
                                            multiple
                                            show-size
                                            truncate-length="44"
                                            v-model="files"
                                        ></v-file-input>
                                        <v-text-field
                                            :rules="[
                                                (v) =>
                                                    !!v ||
                                                    'svc_hour is required',
                                            ]"
                                            label="Description"
                                            v-model="description"
                                        ></v-text-field>
                                    </v-card-text>

                                    <v-divider></v-divider>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>

                                        <v-btn
                                            color="primary"
                                            :disabled="!valid"
                                            text
                                            @click="uploadfile()"
                                        >
                                            Save
                                        </v-btn>
                                        <v-btn
                                            color="primary"
                                            text
                                            @click="dialog = false"
                                        >
                                            Cancel
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-form>
                    </div>
                    <v-row>
                        <v-col>
                            <v-btn
                                v-if="team_name == 'ODM'"
                                color="primary"
                                @click=";(dialog = true), (files = [])"
                                dark
                                ><v-icon left small>mdi-file</v-icon>Upload
                                File</v-btn
                            >
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col
                            v-for="(view_upload, i) in view_upload"
                            :key="i"
                            cols="12"
                            sm="6"
                            md="6"
                        >
                            <v-row>
                                <v-col
                                    cols="12"
                                    sm="6"
                                    md="9"
                                    :class="i % 2 == 0 ? 'bg1' : 'bg2'"
                                    ><label style="font-weight: bold"
                                        >Description :
                                    </label>
                                    <label
                                        >{{ view_upload.file_name }} /
                                    </label>
                                    <br />
                                    <label style="font-weight: bold"
                                        >File_Name :
                                    </label>
                                    <label
                                        >{{
                                            view_upload.file_store_name
                                        }} </label
                                    ><br />
                                    <label style="font-weight: bold"
                                        >Upload By :
                                    </label>
                                    <label>{{ view_upload.name_en }} </label>
                                </v-col>
                                <v-col
                                    cols="12"
                                    sm="6"
                                    md="3"
                                    :class="i % 2 == 0 ? 'bg1' : 'bg2'"
                                >
                                    <v-btn
                                        x-small
                                        :href="showfile + view_upload.file_id"
                                        color="#84fafa"
                                    >
                                        <v-icon left small>mdi-file</v-icon
                                        >Download</v-btn
                                    >
                                    <v-btn
                                        v-if="team_name == 'ODM'"
                                        class="ml-2"
                                        x-small
                                        color="#f57f9a"
                                        @click="
                                            delete_fileupload(
                                                view_upload.file_id,
                                                view_upload.file_store_name
                                            )
                                        "
                                    >
                                        <v-icon left small>mdi-delete</v-icon
                                        >Delete</v-btn
                                    >
                                </v-col>
                            </v-row>
                        </v-col>

                        <!-- <v-col cols="12" sm="6" md="4">
              <v-row
                style="text-align:center;border:1px solid black;background-color:#d9fde9;font-weight:bold;"
              >
                <v-col>
                  Action
                </v-col>
              </v-row>
              <v-row>
                <v-col style="text-align:left;border:1px solid black;">
                  <v-btn :href="showfile + view_upload.file_id" color="#84fafa">
                    <v-icon left small>mdi-file</v-icon>Download</v-btn
                  >
                  /
                  <v-btn
                    color="#f57f9a"
                    @click="
                      delete_fileupload(
                        view_upload.file_id,
                        view_upload.file_store_name
                      )
                    "
                  >
                    <v-icon left small>mdi-delete</v-icon>Delete</v-btn
                  >
                </v-col>
              </v-row>
            </v-col> -->
                    </v-row>
                </v-container>

                <div id="snackbar" class="d-print-none">
                    <v-snackbar v-model="snackbar" color="success" right>{{
                        text
                    }}</v-snackbar>
                </div>
            </v-card-text>
        </v-alert>
        <v-dialog v-model="dialog_loading" hide-overlay persistent width="320">
            <v-card color="primary" dark>
                <v-card-text>
                    <span class="mt-1 white--text">Loading</span>
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"
import resizebase64 from "resize-base64"

export default {
    computed: {
        ...mapState(["snackbar"]),
    },
    props: ["detailcase", "status"],
    data() {
        return {
            dialog_loading: false,
            team_name: localStorage.team_name,

            showfile: `${process.env.VUE_APP_ROOT_API}/api/upload-file/download_uploadfile/`,
            valid: false,
            view_upload: [],
            description: "",
            files: [],
            dialog: false,
            logtype: ["Log", "Follow Up"],
            log: {
                log_note: "",
                status_eeg: false,
                eeg_note: "",
                Attachment: false,
                subcase_id: "",
            },
            text: "Success, Log has been saved",
            text_closecase: "",
        }
    },
    watch: {
        detailcase: function(val) {
            if (!val || !val.maincase_id) return
            // this.get_data(this.onsite_at, this.active_onsite_at)
            if (this.status == "CloseCase") {
                this.log.log_note =
                    this.detailcase.text_closecase + "/" + localStorage.fullname
            } else {
                this.log.log_note = ""
            }
            this.getuploadfile()
        },
    },
    beforeMount() {
        // this.getuploadfile()
    },
    mounted() {
        // console.log(this.detailcase)

        // setTimeout(() => {
        //     this.getuploadfile()
        // }, 2000)

        this.computedGenLog()
    },
    methods: {
        async download_fileupload(file_id) {
            const url = `${process.env.VUE_APP_ROOT_API}/api/case/attachments/${file_id}`

            try {
                const { data } = await axios.get(url)
            } catch (error) {
                console.log(error)
            }
        },
        delete_fileupload(id, file_name) {
            const url = `${process.env.VUE_APP_ROOT_API}/api/`

            this.$swal({
                title: "ต้องการลบไฟล์ " + file_name + " ใช่หรือไม่",
                text: "",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            }).then((del) => {
                if (del) {
                    axios
                        .delete(url + "case/attachments/" + id)
                        .then((response) => {
                            this.$swal({
                                title: "ลบข้อมูลเรียบร้อยครับ !",
                                icon: "success",

                                showConfirmButton: false,
                                timer: 1500,
                            })
                            this.getuploadfile()
                        })
                        .catch((error) => {
                            console.log(error)
                        })
                }
            })
        },
        computedGenLog() {
            // this.log.log_note = ""
            if (this.status == "CloseCase") {
                this.log.log_note =
                    this.detailcase.text_closecase + "/" + localStorage.fullname
            } else {
                this.log.log_note = ""
            }
        },
        ...mapMutations(["mutatesnackbar"]),
        async saveLog() {
            // console.log(this.detailcase, "-detailcase")
            this.dialog_loading = true

            if (this.log.status_eeg == true) {
                if (this.log.Attachment == false) {
                    this.dialog_loading = false

                    let datax = {
                        CaseExchange: {
                            EventType: "PartnerUpdates",
                            EventSubType: "Updates",
                            Originator: "EEG_qASi4aFrltEdrAvEJI7raTLrLswa",
                            IncomingChannel: "EEG",
                            WorkOrder: {
                                WorkOrderID: this.detailcase.wonumber,
                                PartnerName: "APJ_Acacia_P",
                                PartnerStatusDateTime: this.cal_date_eegX(
                                    "main",
                                    ""
                                ),
                            },
                            Notes: {
                                NotesDescription:
                                    "$#" +
                                    this.log.eeg_note +
                                    "  " +
                                    this.log.log_note +
                                    "#$",
                                ExternallyVisible: "Yes",
                            },
                            Attachment: {
                                FileType: null,
                                FileName: null,
                                FileContent: null,
                            },
                        },
                    }
                    this.log.eeg = {
                        Note_Update_All: datax,
                    }
                    this.log.project_name = this.detailcase.project_name
                    this.saveLogX()
                } else {
                    const pdf2base64 = require("pdf-to-base64")
                    pdf2base64(
                        `https://api.aittservice.com/api/hpi/download-cso/${this.detailcase.subcase_id}`
                    )
                        .then((response) => {
                            this.dialog_loading = false

                            let datax = {
                                CaseExchange: {
                                    EventType: "PartnerUpdates",
                                    EventSubType: "Updates",
                                    Originator:
                                        "EEG_qASi4aFrltEdrAvEJI7raTLrLswa",
                                    IncomingChannel: "EEG",
                                    WorkOrder: {
                                        WorkOrderID: this.detailcase.wonumber,
                                        PartnerName: "APJ_Acacia_P",
                                        PartnerStatusDateTime: this.cal_date_eegX(
                                            "main",
                                            ""
                                        ),
                                    },
                                    Notes: {
                                        NotesDescription:
                                            "$#" +
                                            this.log.eeg_note +
                                            "  " +
                                            this.log.log_note +
                                            "#$",
                                        ExternallyVisible: "Yes",
                                    },
                                    Attachment: {
                                        FileType: "application/pdf",
                                        FileName:
                                            this.detailcase.case_id + ".pdf",
                                        FileContent: response,
                                    },
                                },
                            }
                            this.log.eeg = {
                                Note_Update_All: datax,
                            }

                            this.saveLogX()
                        })
                        .catch((error) => {
                            console.log(error) //Exepection error....
                        })
                }
            } else {
                this.saveLogX()
            }
        },
        async saveLogX() {
            this.log.project_name = this.detailcase.project_name
            this.log.subcase_id = this.detailcase.subcase_id
            console.log(this.log, "- save log")
            this.dialog_loading = true

            const url = `${process.env.VUE_APP_ROOT_API}/api/savelog/${this.detailcase.maincase_id}`
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            try {
                let { data } = await axios.post(url, this.log, options)
                console.log(data, "-res data")

                this.log = {
                    log_note: "",
                    status_eeg: false,
                    eeg_note: "",
                    Attachment: false,
                }
                this.dialog_loading = false
                this.detailcase.lognote = data.lognote
                this.dialog_loading = false
                this.computedGenLog()
                if (this.snackbar === true) {
                    setTimeout(() => {
                        this.snackbar
                    }, 2000)
                }
            } catch (error) {
                console.log(error.message)
            }
        },
        async getuploadfile() {
            const url =
                `${process.env.VUE_APP_ROOT_API}/api/upload-file/` +
                this.detailcase.maincase_id

            try {
                const { data } = await axios.get(url)
                this.view_upload = data
            } catch (error) {
                console.log(error)
            }
        },
        async uploadfile() {
            const url = `${process.env.VUE_APP_ROOT_API}/api/upload-file/upload-image/`
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                    "Content-Type": "multipart/form-data",
                },
            }

            try {
                let formData = new FormData()
                formData.append("maincase_id", this.detailcase.maincase_id)
                formData.append("description", this.description)

                if (undefined !== this.files && this.files.length) {
                    for (let i = 0; i < this.files.length; i++) {
                        formData.append(`files[${i}]`, this.files[i])
                    }
                }

                const { data } = await axios.post(url, formData, options)
                this.dialog = false
                this.getuploadfile()
            } catch (error) {
                console.log(error)
            }
        },
        doCopy: function() {
            navigator.clipboard.writeText(
                this.log.log_note != ""
                    ? this.log.log_note
                    : this.text_closecase
            )
        },
        cal_date_eegX(st1, st2) {
            let date = new Date()
            var h = date.getHours()
            var m = date.getMinutes()
            var s = date.getSeconds()
            let year = date.toLocaleString("default", {
                year: "numeric",
            })
            let month = date.toLocaleString("default", {
                month: "2-digit",
            })
            let day = date.toLocaleString("default", { day: "2-digit" })

            if (st1 == "main") {
                let dateD = `${year}-${month}-${day}T${h}:${m}:${s}Z`
                let myArray = dateD.split(" ")
                let arr1 =
                    myArray.length == 1
                        ? myArray[0].split("-")
                        : myArray[1].split("-")
                let formattedDate =
                    myArray.length == 1
                        ? dateD
                        : `${arr1[0] - 543}-${arr1[1]}-${arr1[2]}`

                return formattedDate
            }
        },
        // async getLog() {
        //   const url = `${process.env.VUE_APP_ROOT_API}/api/getlog/${this.$route.params.caseid}`;
        //   try {
        //     const { data } = await axios.get(`${url}`);
        //     this.detailcase.lognote = data.lognote;
        //   } catch (error) {
        //     console.log(error);
        //   }
        // }
    },
    computed: {},
    // beforeUpdate() {
    //   this.getLog();
    // }
}
</script>

<style scoped>
.bg1 {
    background-color: #d9fde9;
}

.bg2 {
    background-color: #eaeaea;
}
</style>
